import { AppState } from '../reducers';

export const selectAssessmentsState = (state: AppState) => state.assessments;
export const selectAssessmentsStateError = (state: AppState) =>
    state.assessments.error;
export const selectAssessmentsById = (state: AppState) =>
    state.assessments.byId;

export const selectAssessmentDataById =
    (assessmentId: string) => (state: AppState) => {
        return state.assessments.byId[assessmentId].data;
    };
